import { FileCardProps } from './Types'
import { MediaFileCardContainer } from './MediaFileCardContainer'
import { FileCard } from './FileCard'
import { FilePreview } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/FilePreview'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Design, Document } from 'blaze-ui/icons'
import { Icon as IconType, IconSizeProps } from 'blaze-ui/icons/Types'
import { FileType } from 'types'
import { FolderFilledIcon } from 'components/FolderFilledIcon/FolderFilledIcon'
import { useBlogIntegrations } from 'hooks/useBlogIntegrations'
import { getBlogPlatformBrandingWithOnboardingSelection } from 'screens/Calendar/WeekViewV2/CalendarEventCard/utils'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const FileTypeCard = ({ file, isTransparentIcon = true, brandPlan, ...props }: FileCardProps) => {
  const { type, channel } = file
  const fileType = type as FileType

  const goHighLevelEnabled = useFlipperFlag('go_high_level_integration')
  const wixEnabled = useFlipperFlag('wix_blog_integration')
  const blogPlatformOnboardingBrandingEnabled = useFlipperFlag('blog_platform_onboarding_branding')
  const { connectedBlogIntegration } = useBlogIntegrations()

  if (fileType === 'media_file') {
    return <MediaFileCardContainer file={file} {...props} />
  }

  let Icon: IconType | undefined = undefined

  if (channel) {
    Icon = ({ size }: IconSizeProps) => {
      const blogPlatformBranding = getBlogPlatformBrandingWithOnboardingSelection({
        channel,
        externalIntegrations: connectedBlogIntegration ? [connectedBlogIntegration] : [],
        selectedBlogPlatform: brandPlan?.selected_blog_platform,
        featureFlags: {
          goHighLevelEnabled,
          wixEnabled,
          blogPlatformOnboardingBrandingEnabled,
        },
      })

      return (
        <ChannelIcon
          size={size}
          channel={channel}
          defaultIcon={fileType === 'design' ? Design : Document}
          isTransparentBackground={isTransparentIcon}
          blogPlatform={blogPlatformBranding}
        />
      )
    }
  }

  if (fileType === 'folder') {
    Icon = ({ size }: IconSizeProps) => <FolderFilledIcon size={size} />
  }

  return <FileCard preview={FilePreview} file={file} icon={Icon} {...props} />
}
